/**
 * Wave 14 Agent TRIAL - Layer 3.
 *
 * Day 10+ in-app prompt that nudges the trialist to an annual plan or
 * the pilot. Renders nothing earlier in the trial; renders nothing
 * after dismissal in localStorage.
 */
import { useState } from 'react'
import { useTrialStatus } from '@/hooks/useTrialStatus'

const STORAGE_KEY = 'wave14_annual_prompt_dismissed'

export function AnnualUpgradePrompt() {
  const { status, daysElapsed } = useTrialStatus()
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      return false
    }
  })

  if (!status || !status.in_trial || daysElapsed < 10 || dismissed) {
    return null
  }

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1')
    } catch {
      /* noop */
    }
    setDismissed(true)
  }

  return (
    <div
      data-testid="annual-upgrade-prompt"
      className="fixed bottom-4 right-4 max-w-sm rounded-xl bg-white border border-slate-200 shadow-xl p-4 z-40"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-semibold mb-1">
            Loving ORKSTRA so far?
          </div>
          <p className="text-sm text-slate-600">
            You have {status.days_remaining} days left. Upgrade now and we
            credit your remaining trial against the annual price.
          </p>
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="text-slate-400 hover:text-slate-700"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
      <div className="flex items-center gap-2 mt-3">
        <a
          href="/billing"
          className="px-3 py-1 rounded bg-blue-600 text-white text-sm hover:bg-blue-700"
        >
          See plans
        </a>
        <a
          href="/pilot/apply"
          className="px-3 py-1 rounded border border-slate-300 text-sm hover:bg-slate-50"
        >
          Or try the pilot
        </a>
      </div>
    </div>
  )
}

export default AnnualUpgradePrompt
